module.exports = __webpack_public_path__ + "static/media/vlogix_logo.3097cd3a.png";